import { Component } from '@angular/core';

@Component({
    selector: 'app-collections-config',
    template: `
        <app-collection-areas-dialog></app-collection-areas-dialog>
        <app-config-contact-info></app-config-contact-info>
    `,
})
export class CollectionsConfigComponent {}
